import React, { useEffect, useRef, useState } from 'react';

import { Container } from './styles';

type IframeProps = React.IframeHTMLAttributes<HTMLIFrameElement> & {
  updateIframeTime?: number;
  headers?: HeadersInit;
};

const Iframe: React.FC<IframeProps> = ({
  title = 'iframe',
  src,
  updateIframeTime,
  headers,
  ...rest
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [iframeSrc, setIframeSrc] = useState('');
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const currentUrlRef = useRef<string | null>(null);

  async function loadContent(): Promise<void> {
    try {
      const response = await fetch(src || '', {
        method: 'GET',
        headers,
      });

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      if (currentUrlRef.current) {
        URL.revokeObjectURL(currentUrlRef.current);
      }
      currentUrlRef.current = objectUrl;
      setIframeSrc(objectUrl);
    } catch (error) {
      console.error('Erro ao carregar o conteúdo:', error);
    }
  }

  useEffect(() => {
    loadContent();

    return () => {
      if (currentUrlRef.current) {
        URL.revokeObjectURL(currentUrlRef.current);
      }
    };
  }, [src]);

  useEffect(() => {
    if (updateIframeTime) {
      intervalRef.current = setInterval(() => {
        loadContent();
      }, updateIframeTime);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (currentUrlRef.current) {
        URL.revokeObjectURL(currentUrlRef.current);
      }
    };
  }, [updateIframeTime]);

  useEffect(() => {
    const updateHeight = (): void => {
      if (containerRef.current) {
        setHeight(containerRef.current.getBoundingClientRect().height);
      }
    };

    updateHeight();

    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  return (
    <Container ref={containerRef}>
      <iframe
        {...rest}
        src={iframeSrc}
        title={title}
        height={height}
        style={{ width: '100%', border: '0', ...rest.style }}
      />
    </Container>
  );
};

export default Iframe;
